module.exports = __webpack_public_path__ + "media/images/flags/bs-1beb8731e787d165e806ded33ed867b0.svg";